import {
  init,
  tanstackRouterBrowserTracingIntegration,
  thirdPartyErrorFilterIntegration,
} from '@sentry/react';
import { isHTTPError, isNetworkError, isTimeoutError, NetworkError } from 'ky';
import { router } from './router';

init({
  release: import.meta.env.NX_PUBLIC_APP_VERSION,
  dsn: 'https://4b696cb10234a35624846cdb6c571175@o467009.ingest.us.sentry.io/4511307632738304',
  environment: import.meta.env.NX_PUBLIC_SENTRY_ENVIRONMENT ?? 'development',
  sendDefaultPii: true,
  integrations: [
    tanstackRouterBrowserTracingIntegration(router),
    thirdPartyErrorFilterIntegration({
      filterKeys: [import.meta.env.NX_PUBLIC_SENTRY_APP_KEY],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
  beforeSend(event, hint) {
    const error = hint.originalException;

    if (error instanceof NetworkError) {
      return null;
    }

    if (error instanceof DOMException && error.name === 'AbortError') {
      return null;
    }

    // 过滤掉无法
    if (isHTTPError(error)) {
      const { status: http_status } = error.response;
      if (
        http_status >= 500 ||
        http_status === 400 ||
        http_status === 422 ||
        http_status === 401 ||
        http_status === 403
      ) {
        return null;
      }
    }

    if (isTimeoutError(error)) {
      return null;
    }

    if (isNetworkError(error)) {
      return null;
    }

    return event;
  },

  tracesSampleRate: 0.2,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^\//],
});
